import { Controller, useFormContext } from 'react-hook-form';
import { Tag01 } from '@untitledui/icons';
import { Input } from '@/components/base/input/input';
import { AUTH_FORM_SIZE } from '@/shared/config/auth-form';
import type { SignupFormValues } from '../schema';

export const Step07Segmento = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SignupFormValues>();

  return (
    <Controller
      control={control}
      name="segmento"
      render={({ field }) => (
        <Input
          label="Segmento"
          type="text"
          size={AUTH_FORM_SIZE}
          icon={Tag01}
          placeholder="Ex.: Tecnologia, Saúde, Educação"
          autoFocus
          isInvalid={!!errors.segmento}
          hint={errors.segmento?.message}
          value={field.value ?? ''}
          onChange={field.onChange}
          onBlur={field.onBlur}
          name={field.name}
        />
      )}
    />
  );
};
